export const getNameWithColor = (name: string, color: string | undefined) =>
  color ? `${name}-${color}` : name;
